import { useEffect, useRef } from "react"

export function useAutoFocus<T extends HTMLElement>(delay = 100, selector?: string) {
  const ref = useRef<T>(null)

  useEffect(() => {
    const t = setTimeout(() => {
      const el = selector
        ? ref.current?.querySelector<HTMLElement>(selector)
        : ref.current
      el?.focus()
    }, delay)
    return () => clearTimeout(t)
  }, [])

  return ref
}
